
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/custom-voices",
      function () {
        return require("private-next-pages/custom-voices.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/custom-voices"])
      });
    }
  